import STORE from '../../../../store';

const deleteScorecard = async (
  scorecard: Scorecards.Scorecard,
  accountId: string,
) => {
  const { id } = scorecard;

  await STORE.visualisations
    .getScorecardsRef({ accountId })
    .doc(id)
    .update({ isHidden: true });
};

export default deleteScorecard;
